import { comparisonData } from '@/mocks/categories';

export default function AboutSection() {
  return (
    <section className="w-full bg-gradient-to-b from-primary-800 to-primary-950 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/20 text-accent-200 text-xs font-label tracking-wider mb-6">
              // DATABASE
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-6 leading-tight">
              Mulebuy Spreadsheet Database
            </h2>
            <p className="text-background-200/80 text-sm md:text-base leading-relaxed mb-4">
              A <strong className="text-background-50">mulebuy spreadsheet</strong> is a structured data system used to organize product sourcing information, supplier data, and purchasing insights. It transforms chaotic sourcing workflows into organized, searchable databases.
            </p>
            <p className="text-background-300/70 text-sm leading-relaxed mb-6">
              Whether you are sourcing shoes, apparel, accessories, or electronics, a well-maintained mulebuy spreadsheet saves hours of manual research and helps you make data-driven purchasing decisions with confidence.
            </p>

            <div className="flex items-center gap-8 mb-8">
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-background-50">14+</p>
                <p className="text-background-300/70 text-xs mt-1">Categories</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-background-50">Daily</p>
                <p className="text-background-300/70 text-xs mt-1">Updates</p>
              </div>
              <div>
                <p className="font-heading text-4xl md:text-5xl font-bold text-background-50">100%</p>
                <p className="text-background-300/70 text-xs mt-1">Free Access</p>
              </div>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-background-50 text-primary-800 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              See Full List
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="w-full lg:w-3/5">
            <div className="bg-background-50/5 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-background-50/10">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-6">
                Feature Comparison
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead>
                    <tr className="border-b border-background-50/20">
                      <th className="py-3 pr-4 text-sm font-semibold text-background-200">Feature</th>
                      <th className="py-3 px-4 text-sm font-semibold text-background-50">Mulebuy Spreadsheet</th>
                      <th className="py-3 px-4 text-sm font-semibold text-background-300">Traditional Sourcing</th>
                      <th className="py-3 pl-4 text-sm font-semibold text-background-300">Agent Platforms</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comparisonData.map((row, i) => (
                      <tr key={i} className="border-b border-background-50/10">
                        <td className="py-3.5 pr-4 text-sm text-background-100 font-medium">{row.feature}</td>
                        <td className="py-3.5 px-4 text-sm text-accent-200 font-semibold">{row.mulebuy}</td>
                        <td className="py-3.5 px-4 text-sm text-background-300/70">{row.traditional}</td>
                        <td className="py-3.5 pl-4 text-sm text-background-300/70">{row.agents}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}